import { Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { Box } from "components/common"

const GridItem = styled(Box).attrs((props) => ({
  as: "a",
  ...props,
}))`
  margin-bottom: 24px;
  position: relative;
  justify-content: center;
  width: ${(props) => (props.adsize === 1 ? "50%" : "100%")};
  padding: 0 5px;
  ${({ theme }) => theme.mediaQueries.tablet`
      width: 33%;
      margin-bottom: 15px;
    `};
  ${(props) =>
    props.adsize === 2 &&
    `
    ${props.theme.mediaQueries.tablet`
      width: 66%;
    `}
  `}
`

const ImageWrapper = styled.div`
  width: 100%;
`

const StyledVideo = styled.video.attrs({
  className: "lazyload",
  "data-autoplay": "",
  loop: true,
  muted: true,
  playsInline: true,
  preload: "none",
})`
  height: 100% !important;
  width: 100% !important;
  ${({ theme }) => theme.mediaQueries.tablet`
      width: auto !important;
      height: auto !important;
    `};
`

const CollectionAd = ({ ad, counter, position }) => {
  let showMobile = true
  let showTablet = true
  if (position == "before") {
    if (counter % 3 != 1) {
      showTablet = false
    }
    if (counter % 2 != 0) {
      showMobile = false
    }
  } else if (ad.ad_size > 1) {
    // after
    if (counter % 3 == 1) {
      showTablet = false
    }
    if (counter % 2 == 0) {
      showMobile = false
    }
  }
  if (ad.ad_type === "jpg") {
    return (
      <GridItem
        adsize={ad.ad_size}
        as={ad.href && ad.href != "" ? Link : "div"}
        counter={counter}
        data-lc="collection-ad"
        display={{
          _: showMobile ? "flex" : "none",
          tablet: showTablet ? "flex" : "none",
        }}
        position={position}
        to={ad.href}
      >
        <ImageWrapper>
          <Picture
            alt=""
            srcSet={[
              {
                media: "(max-width: 767px)",
                srcSet: `
                  ${ad.jpg.mobile.x1} 1x,
                  ${ad.jpg.mobile.x2} 2x,
                `,
              },
              {
                media: "(min-width: 768px) and (max-width: 1023px)",
                srcSet: `
                ${ad.jpg.tablet.x1} 1x,
                ${ad.jpg.tablet.x2} 2x,
              `,
              },
              {
                media: "(min-width: 1024px)",
                srcSet: `
                ${ad.jpg.desktop.x1} 1x,
                ${ad.jpg.desktop.x2} 2x,
              `,
              },
            ]}
          />
        </ImageWrapper>
      </GridItem>
    )
  } else if (ad.ad_type === "video") {
    return (
      <GridItem
        adsize={ad.ad_size}
        as={ad.href && ad.href != "" ? Link : "div"}
        counter={counter}
        data-lc="collection-ad"
        display={{
          _: showMobile ? "flex" : "none",
          tablet: showTablet ? "flex" : "none",
        }}
        position={position}
        to={ad.href}
      >
        <Box position="relative" width="100%">
          <StyledVideo>
            {ad.webm && ad.webm != "" && (
              <source src={ad.webm} type="video/webm" />
            )}
            {ad.mp4 && ad.mp4 != "" && <source src={ad.mp4} type="video/mp4" />}
          </StyledVideo>
        </Box>
      </GridItem>
    )
  } else {
    return null
  }
}

CollectionAd.propTypes = {
  ad: PropTypes.object,
  counter: PropTypes.number,
  position: PropTypes.string,
}

export default CollectionAd
